import { render, staticRenderFns } from "./LeaveList.vue?vue&type=template&id=297f1c2a"
import script from "../../controllers/leave/leave-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/leave/leave-list.js?vue&type=script&lang=js&external"
import style0 from "./LeaveList.vue?vue&type=style&index=0&id=297f1c2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports